import { Observable } from 'rxjs';
import { TrafficSource } from '../../../shared/_models/models';
import { FusionApiHttpClient } from '../../../shared/_services/server-clients';

// Traffic source endpoints return plain data, not ResponseFromServer wrappers.
// Using getRaw/postRaw/putRaw/deleteRaw to bypass the .data unwrapping.
export class TrafficSourcesApiService {
  constructor(private readonly fusionApiHttpClient: FusionApiHttpClient) {}

  getAll(): Observable<TrafficSource[]> {
    return this.plainResponse(this.fusionApiHttpClient.getRaw('trafficSource/'));
  }

  getById(id: number | string): Observable<TrafficSource> {
    return this.plainResponse(this.fusionApiHttpClient.getRaw(`trafficSource/${id}`));
  }

  create(data: Partial<TrafficSource>): Observable<TrafficSource> {
    return this.plainResponse(this.fusionApiHttpClient.postRaw('trafficSource/', data));
  }

  update(id: number | string, data: Partial<TrafficSource>): Observable<TrafficSource> {
    return this.plainResponse(this.fusionApiHttpClient.putRaw(`trafficSource/${id}`, data));
  }

  delete(id: number | string): Observable<void> {
    return this.plainResponse(this.fusionApiHttpClient.deleteRaw(`trafficSource/${id}`));
  }

  getSspList(): Observable<unknown[]> {
    return this.plainResponse(this.fusionApiHttpClient.getRaw('trafficSource/ssp'));
  }

  private plainResponse<T>(source$: Observable<unknown>): Observable<T> {
    return source$ as Observable<T>;
  }
}
